module.exports = __webpack_public_path__ + "img/1.4717e222.jpg";